// extracted by mini-css-extract-plugin
module.exports = {"anchor":"styles_anchor__1iZCG","row":"styles_row__265Pg","header":"styles_header__2Merb"};